import { InjectionToken } from '@angular/core';

export const ERROR_PAGE_DESCRIPTION = new InjectionToken<string>('description for Error page', {
  factory: () => '',
});
